<div class="validation-error">
  <i class="material-symbols-outlined">error_outline</i>
  <span class="error-message" [innerHTML]="error"></span>
</div>
